import { RouterView } from "vue-router"
import { defineComponent, type ReactiveComponent } from "vue-utils"

const MainApp: ReactiveComponent = () => {
	return () => <RouterView />
}

export default defineComponent(MainApp)
